import EditDeepLinkForm from "./EditDeepLinkForm";

export * from "./EditDeepLinkForm.schema";

export default EditDeepLinkForm;
